<template>
    <div class="d-flex flex-column h-100 sidebar bg-trans-gradient">
        <div class="d-flex flex-grow-1 align-items-center justify-content-center">
            <router-link :to="{ name: 'portal.home' }" class="">
                <img :src="assetsPathGlobalPlatform('/logo.svg')" alt="">
            </router-link>
        </div>
        <div class="side-footer d-flex justify-content-center align-items-center">
            <a href="https://www.municipia.pt" target="_blank">
                <img :src="logoIcon" alt="">
            </a>
        </div>
    </div>
</template>

<script>
import GlobalMixin from '@/app/shared/mixins/global';
import LogoWhiteIcon from '@images/logo-municipia-white.png';

export default {
    mixins: [
        GlobalMixin
    ],
    computed: {
        logoIcon() {
            return LogoWhiteIcon;
        },
    }
}
</script>

<style scoped lang="scss">

.sidebar{
    img{
        width: 150px;
    }

    .side-footer {
        height: 200px;

        img {
            width: 70px;
        }
    }
}
</style>
